import styled from 'styled-components';

import SpinnerDef from 'components/Spinner';

export const Spinner = styled(SpinnerDef)`
  flex: 1 1 auto;
`;
